<template>
  <div class="cpl">
    <div class="cpl-header">
      <h2>开发人员</h2>
    </div>
    <div class="cpl-body">
      <div class="gt-form"
           style="padding-right:0;">
        <div class="gt-form-item is-required">
          <label class="gt-form-item__label">请下载模版</label>
          <div class="gt-form-item__content">
            <div class="gt-input">
              <a class="template-btn"
                 download
                 href="/apiService/virus/common/getTemplate/devMember"
                 target="_blank">开发人员列表.xlsx</a>
            </div>
          </div>
        </div>
        <div class="gt-form-item is-required">
          <label class="gt-form-item__label"
                 style="width: 208px; text-align: left;">开发人员列表（最少五人）</label>
          <div class="gt-form-item__content"
               style="margin-left: 208px;">
            <div class="gt-input">
              <upload-unit ref="devList"
                           tip="支持xls，xlsx类型文件"
                           url="/virus/sdk/memberInfo/upload"
                           :limitType="limitType"
                           v-model="references.devMember"></upload-unit>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadUnit from './../upload_unit'
export default {
  name: 'Developer',
  inject: ['sourceData'],
  components: {
    UploadUnit
  },
  data () {
    let references = this.sourceData.materials
    return {
      references,
      loading: false,
      limitType: ['xls', 'xlsx']
    }
  },
  // computed: {
  //   userInfo () {
  //     return this.$store.getters.getAccount
  //   }
  // },
  methods: {
    generateParams () {

    },
    uploadSuccess (file, name) { },
    uploadClear (name) { },
    validate () {
      return this.$refs.devList.validate()
    },
    send () {
      this.submitParams.phone = this.userInfo.phone
    }
  },
  created () {

  }
}
</script>

<style lang='less' scoped>
.cpl {
  margin-bottom: 20px;
  .cpl-header {
    display: flex;
    height: auto;
    padding-bottom: 16px;
    margin-bottom: 0 !important;
    align-items: center;
    border-bottom: 1px solid #dddddd;
  }
  .cpl-body {
    text-align: left;
    // border: 1px solid #dddddd;
    border: none !important;
    .gt-form {
      padding-left: 0;
    }
  }
  .cpl-footer {
    text-align: left;
  }
}
.template-btn {
  font-size: 14px;
  color: #4384bc;
  text-decoration: underline;
}
/* form */
.gt-form--inline .gt-form-item__label {
  width: 120px;
  text-align: left;
}
.gt-form-item__content {
  margin-left: 120px;
}
</style>
